import { CorporateAdminStatus } from '../../enums';

export interface UpdateCorporateAdminDto {
  locationId?: string | null; // Guid
  positionId?: string | null; // Guid
  roleId?: string | null; // Guid
  firstName: string; // Required, max 100
  lastName: string; // Required, max 100
  email: string; // Required, email, max 320
  contactNumber?: string | null; // Phone, max 20
  hireDate: string; // Required, DateOnly as ISO string (YYYY-MM-DD)
  status?: CorporateAdminStatus;
  isActive?: boolean;
}
